export const onCreatePipelineResult = /* GraphQL */ `
  subscription OnCreatePipelineResult {
    onCreatePipelineResult {
      id
      recordCloudResourceId
      timestamp
      status
      info
    }
  }
`;
export const onCreateInsightMessage = /* GraphQL */ `
  subscription OnCreateInsightMessage($userId: String) {
    onCreateInsightMessage(userId: $userId) {
      id
      workspaceUserId
      userId
      createdAt
      role
      content
    }
  }
`;

// Snapshots of the caller's running insights turns (BEEM-1448). Owner-scoped by the generated
// resolver: pass the current user's id. Fired by the connector's updateInsightTurn, whose
// selection set must include every field selected here, since AppSync only delivers those.
export const onUpdateInsightTurn = /* GraphQL */ `
  subscription OnUpdateInsightTurn($userId: String) {
    onUpdateInsightTurn(userId: $userId) {
      id
      userId
      workspaceId
      sessionId
      status
      answerText
      reasoningText
      steps
      memoryCount
      error
      ttl
      createdAt
      updatedAt
    }
  }
`;

// AppSync subscription on GenerativeDashboard updates. Used by the
// View page to receive lambda-driven state transitions (progressStep,
// renderContent, wiringScript, drilldownScript, conversationHistory,
// status flips) the instant they hit DDB — eliminates the ~750ms avg
// poll latency that previously sat between every DDB write and the UI
// catching it. Subscription is filtered by dashboard id client-side
// in the View (AppSync's subscribe-by-key would require a model
// keyspec change). The View keeps a 5s polling fallback for resilience
// to subscription drops.
export const onUpdateGenerativeDashboard = /* GraphQL */ `
  subscription OnUpdateGenerativeDashboard {
    onUpdateGenerativeDashboard {
      id
      name
      workspaceId
      prompt
      conversationHistory
      renderContent
      publishedRenderContent
      editVersions
      publishedVersions
      drilldownScript
      drilldownStatus
      wiringScript
      wiringPrelude
      cardWiringMap
      renderContentKey
      publishedRenderContentKey
      wiringScriptKey
      drilldownScriptKey
      wiringPreludeKey
      status
      errorMessage
      progressStep
      createdBy
      createdAt
      updatedAt
    }
  }
`;
